import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const skeletonGroupDriverFactory = (base, body) => {
  return {
    ...baseUniDriverFactory(base, body),
  };
};
